import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import SimpleLoadingSpinner from '@src/components/SimpleLoadingSpinner';
import TranscriptEditorContent from './TranscriptEditorContent';

/**
 * TranscriptEditorTab - Component for integrating the transcript editor into the ContentStudio
 * This wrapper handles waiting for the story ID to be available before rendering the actual editor
 */
const TranscriptEditorTab: React.FC = observer(() => {
  const videoCreator = useVideoCreatorStore();
  const story = videoCreator?.story;
  
  // Wait for the story to be loaded before we try to initialize the editor
  if (!story?.id) {
    return (
      <LoadingContainer>
        <SimpleLoadingSpinner text="Loading story data..." />
      </LoadingContainer>
    );
  }
  
  // Story has loaded, now we can render the actual editor component
  return <TranscriptEditorContent />;
});

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  gap: 20px;
`;

const LoadingText = styled.div`
  font-size: 16px;
  color: #f3e9d7;
`;

export default TranscriptEditorTab;